import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getCustomerList = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/customer/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      die_group: groupId,
      ordering: ordering,
    },
  });
};

const getCustomerDropdown = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/customer/', {
    headers: authHeader(),
    params: {
      fields: 'id,customer_name,delivery_days,deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      die_group: groupId,
      ordering: ordering,
    },
  });
};

const getActiveCustomerList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/active-customers/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};
const getCustomerConversion = (
  page,
  pagesize,
  search,
  customer_id,
  die_id,
  ordering,
) => {
  return axios.get(
    API_URL +
    '/api/' +
    API_VERSION +
    '/customer/get-conversion-rate-by-customer/',
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        customer_id: customer_id,
        die_id: die_id,
        ordering: ordering,
      },
    },
  );
};
const getCustomerConversionValue = (
  page,
  pagesize,
  search,
  customer_id,
  die_id,
alloy_id,
temper_id,
) => {
  return axios.get(
    API_URL +
    '/api/' +
    API_VERSION +
    '/customer/get-conversion-rate-by-customer/',
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        customer_id: customer_id,
        die_id: die_id,
        alloy_id: alloy_id,
        temper_id: temper_id,
      },
    },
  );
};
const getCustomerArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/customer/archive-list', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getCustomerById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/customer/${id}`, {
    headers: authHeader(),
  });
};
const addCustomer = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/customer/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};
const addQuickCustomer = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/customer/quick-customer-add/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};
const updateCustomer = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/customer/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};
const deleteCustomer = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/customer/${id}/archive/`,
    {},
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveCustomerRecord = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/customer/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const customerService = {
  getCustomerList,
  getCustomerConversion,
  getCustomerConversionValue,
  getCustomerArchiveList,
  getCustomerById,
  addCustomer,
  addQuickCustomer,
  updateCustomer,
  deleteCustomer,
  unArchiveCustomerRecord,
  getCustomerDropdown,
  getActiveCustomerList
};

export default customerService;
